import { AbstractFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/factories/AbstractFreewheelRequestFactory';
import { FreewheelDaiApiRequest } from 'tag/ts/tag/ads/freewheel/requests/FreewheelDaiApiRequest';
export class FreewheelDaiApiRequestFactory extends AbstractFreewheelRequestFactory {
    constructor(argument) {
        super({
            ...argument,
            name: 'FreewheelDaiApiRequestFactory'
        });
    }
    createRequest() {
        const request = new FreewheelDaiApiRequest({ tag: this.tag });
        this?.logger?.log('createRequest', 'returning FreewheelDaiApiRequest:', request);
        return request;
    }
}
